import { Members } from "../../../listsSettings/members";

export const allItems: string = `/${Members.InternalName}/_lists/${Members.Lists.LegalRepresentatives.InternalName}/_pages/all_items`;
